import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=ee484a4c"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee484a4c')) {
      api.createRecord('ee484a4c', component.options)
    } else {
      api.reload('ee484a4c', component.options)
    }
    module.hot.accept("./FullPage.vue?vue&type=template&id=ee484a4c", function () {
      api.rerender('ee484a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/FullPage.vue"
export default component.exports